import styled from 'styled-components'

interface RadioContainerProps {
  checked: boolean;
}

export const RadioContainer = styled.div<RadioContainerProps>`
  height: 240px;
  width: 240px;
  border: ${props => props.checked ? '4px solid #3D6666' : '2px solid #C8C8C8'};
  background: ${props => props.checked ? '#F5F9F9' : '#FFF'};
  display: flex;
  flex-direction: column;
  cursor: pointer;

  & input {
    display: none;
  }

  & .ball {
    border: ${props => props.checked ? '8px solid #3D6666' : '2px solid #C8C8C8'};
    border-radius: 50%;
    height: 32px;
    width: 32px;
    margin: 16px 0 0 16px;
  }

  @media only screen and (max-width: 730px) {
    height: 180px;
    width: 180px;

    & .ball {
      height: 26px;
      width: 26px;
      margin: 8px 0 0 8px;
    }
  }
`

export const RadioContent = styled.div<RadioContainerProps>`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;

  & span {
    font-weight: 900;
  }

  & > div {
    height: 120px;
    width: 120px;
    border-radius: 50%;
    background-color: ${props => props.checked ? "#FFF" : "#EBF2F2"};
    display: flex;
    align-items: center;
    justify-content: center;
  }

  & img {
    height: 54px;
    width: 54px;
  }

  @media only screen and (max-width: 730px) {
    & > div {
      height: 96px;
      width: 96px;
    }
    
    & img {
      height: 42px;
      width: 42px;
    }
  }
`